<div
  class="ops-select-container"
  [class.disabled]="isDisabled"
  (click)="handlePropagation($event)"
>
  <label *ngIf="label" class="ops-select-label">
    {{ label }}
    <span *ngIf="mandatory">&nbsp;*</span>
    <span class="delimiter"></span>
    <span
      *ngIf="maxSelect && showLimitNote && !isPreview"
      class="ops-select-note on-top"
    >
      {{ 'labels.selectUpTo' | translate }} {{ maxSelect }}
    </span>
  </label>

  <div class="ops-select-input-wrapper" [class.disabled]="isDisabled">
    <div
      class="ops-select-input"
      [class.rotate-direction]="rotateDropdownDirection"
      [class.open]="isDropdownOpen"
      [class.disabled]="isDisabled"
      [class.preview]="isPreview"
    >
      <div *ngIf="isPreview || isSingleOption" class="preview">
        {{ selectedValue }}
      </div>

      <input
        *ngIf="!isPreview && !isSingleOption"
        type="text"
        (click)="onClick()"
        (focus)="onFocus($event)"
        (blur)="onBlur()"
        [placeholder]="placeholder"
        [readonly]="!showSearch"
        [disabled]="isDisabled"
        [value]="selectedValue"
        [(ngModel)]="searchQuery"
        (input)="onSearchChange($event)"
        (keydown)="onKeyDown($event)"
        (keydown.enter)="onEnterPressed($event)"
        [attr.autofocus]="setFocus ? true : null"
      />
      <div
        (click)="ddIconClick()"
        *ngIf="!isPreview && !isSingleOption"
        class="dropdown-icon"
      ></div>
    </div>
    <!-- Dropdown -->

    <ul
      class="dropdown"
      [class.rotate-direction]="rotateDropdownDirection"
      *ngIf="isDropdownOpen && !isPreview && !isSingleOption"
    >
      <!-- <li>
        <span class="selected-item">+ Add New</span>
      </li> -->
      <li
        *ngFor="let item of filteredItems; let i = index"
        [ngClass]="getItemClass(item)"
        (click)="onSelectItem(item)"
      >
        <ng-container
          *ngIf="listItemType === 'checkbox' || listItemType === 'radio'"
        >
          <input
            [type]="listItemType"
            [checked]="isSelected(item)"
            tabindex="-1"
            [disabled]="isDisabled"
          />
        </ng-container>

        {{ item.value }}
      </li>
    </ul>
  </div>

  <div *ngIf="noteText && !isPreview" class="ops-select-note">
    {{ noteText }}
  </div>

  <div *ngIf="showError && errorMessage && !isPreview" class="ops-select-error">
    {{ errorMessage }}
  </div>

  <div class="selected-items" *ngIf="isMultiselect && selectedItems.length">
    <span
      *ngFor="let item of selectedItems"
      class="selected-item"
      [class.disabled]="isDisabled || isPreview"
      (click)="removeSelectedItem(item)"
    >
      {{ item.value || item }}
      <button tabindex="-1">x</button>
    </span>
  </div>
</div>
